import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { formatStoreCredit } from '@helpers/index';
import { getCustomerSelector } from '@modules/customer/core/selectors';
import { getCurrencyCodeSelector } from '@modules/subscriptions/core/selectors';
import { toAbsoluteUrl } from '@shared';

export const StoreCreditPfotenpunkteCard = () => {
  const intl = useIntl();
  const customer = useSelector(getCustomerSelector);
  const currencySymbol = useSelector(getCurrencyCodeSelector);
  const storeCreditBalance = customer?.storeCredit?.total_balance ?? 0;
  const currencyCode = customer?.storeCredit?.currency_code ?? 'EUR';

  const formattedStoreCredit = formatStoreCredit(
    storeCreditBalance,
    currencyCode,
    currencySymbol,
    intl.locale,
  );

  const storeCreditNumber = storeCreditBalance.toFixed(2);

  const shopUrl = '/mitbestellen';

  const shineButtonClasses = clsx(
    'relative overflow-hidden w-fit z-[1] rounded-full',
    'px-[17px] py-[13px] lg:text-[14px] lg:leading-[20px] text-[16px] leading-[22px]',
    'whitespace-nowrap font-bold text-white bg-primary',
    'hover:bg-[#005f58] transition duration-200',
    'before:absolute before:inset-0 before:z-[1] before:pointer-events-none',
    'before:bg-[linear-gradient(90deg,_#fff0_0,_#fffc_50%,_#80bae800_99%,_#7db9e800)]',
    'before:animate-highlight',
  );

  return (
    <div
      className={clsx(
        'relative [&_p]:relative overflow-hidden max-w-[500px] mx-auto [&_p]:z-1 flex gap-[18px] flex-col justify-between p-[15px] w-full rounded-[20px] lg:px-[30px] lg:py-[25px]',
        location.pathname === '/mitbestellen' ? 'hidden' : '',
      )}>
      <img
        src={toAbsoluteUrl('/media/svg/store-credit/pfotenpunkte-card.svg')}
        alt="Pfotenpunkte"
        className="absolute inset-0 w-full h-full object-cover rounded-[20px]"
      />
      <p className="text-[18px] leading-[24px] font-bold text-primary">
        <FormattedMessage id="STORE_CREDIT.CARD.YOU_HAVE" />
        <span
          className={clsx(
            'block text-[40px] leading-[46px] lg:text-[24px] lg:leading-[30px] font-[850] text-primary',
            storeCreditNumber > 1000
              ? 'text-[30px] leading-[36px] lg:text-[20px] lg:leading-[26px]'
              : storeCreditNumber > 100
                ? 'text-[36px] leading-[42px] lg:text-[22px] lg:leading-[28px]'
                : '',
          )}>
          {formattedStoreCredit}
        </span>
        <span className="block text-[22px] leading-[28px] lg:text-[18px] lg:leading-[24px]">
          Pfotenpunkte
        </span>
      </p>
      <div className="block lg:w-[70px] lg:h-[70px] w-[110px] h-[110px] absolute lg:right-[-6px] top-[50%] -translate-y-1/2 lg:translate-y-0 right-[15px] lg:top-[-6px] z-1 rounded-full">
        <img
          src={toAbsoluteUrl('/media/svg/store-credit/pfotenpunkte-icon.svg')}
          alt="Pfotenpunkte"
          className="w-full h-full object-cover"
        />
      </div>
      {storeCreditBalance > 0 ? (
        <Link to="/mitbestellen" className={shineButtonClasses}>
          <span className="relative z-[2]">
            {storeCreditNumber > 0 ? (
              <FormattedMessage id="STORE_CREDIT.REDEEM_POINTS" />
            ) : (
              <FormattedMessage id="SHOP.GO_TO_SHOP" />
            )}
          </span>
        </Link>
      ) : (
        <a href={shopUrl} className={shineButtonClasses}>
          <span className="relative z-[2]">
            <FormattedMessage id="SHOP.GO_TO_SHOP" />
          </span>
        </a>
      )}
    </div>
  );
};
